import { SVGProps, Ref, forwardRef } from 'react';

export const LockOpenedFilledSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.61 1.843c.244.44.404 1.012.484 1.657H12C11.795 1.628 10.967 0 9.052 0 7.292 0 6.45 1.379 6.166 3.057A19 19 0 0 0 4.5 3C.563 3 0 3.563 0 7.5S.563 12 4.5 12 9 11.438 9 7.5c0-2.846-.294-3.929-1.943-4.31.088-.519.234-.98.438-1.347C7.83 1.242 8.301.9 9.052.9s1.223.342 1.557.943M4.95 8.75h-.9v-2.5h.9z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LockOpenedFilledSize12Glyph.displayName = 'LockOpenedFilledSize12Glyph';
